import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export var parseTimeToDate = function parseTimeToDate(time) {
  var _time$split = time.split(':'),
    _time$split2 = _slicedToArray(_time$split, 2),
    hours = _time$split2[0],
    minutes = _time$split2[1];
  var date = new Date();
  date.setHours(+hours);
  date.setMinutes(+minutes);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date;
};